// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__37bqq","topBottomGutter":"Layout_topBottomGutter__22-df"};